import { render, staticRenderFns } from "./FuneralFundsYN.vue?vue&type=template&id=66b5a914"
import script from "./FuneralFundsYN.vue?vue&type=script&lang=js"
export * from "./FuneralFundsYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports